import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ReturnsNotification = ({
  needActionCount,
}: {
  needActionCount: number;
}) => {
  const { t } = useTranslation("common");
  return (
    <Typography data-fuel-size="small">
      {t("notifications.returns.message", { needActionCount })}
    </Typography>
  );
};

export default ReturnsNotification;
